import { combineReducers, UnknownAction } from "redux";
import { configureStore } from "@reduxjs/toolkit";

import authReducer, { setUser } from "./authentication/reducer";
import utilsReducer from "./utils/reducer";
import navigationReducer from "./navigation/reducer.js";
import downloadsReducer from "./downloads/reducer";
import { commonsApi } from "./service.js";
import { setSessionUserListener } from "./api";

const combinedReducer = combineReducers({
  auth: authReducer,
  utils: utilsReducer,
  downloads: downloadsReducer,
  navigation: navigationReducer,
  [commonsApi.reducerPath]: commonsApi.reducer,
});

const rootReducer = (
  state: ReturnType<typeof combinedReducer> | undefined,
  action: UnknownAction,
) => {
  if (action.type === "authentication/logout") {
    state = undefined;
  }
  return combinedReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(commonsApi.middleware);
  },
});

setSessionUserListener((user) => {
  store.dispatch(setUser(user));
});

export type RootState = ReturnType<typeof store.getState>;

export default store;
